// extracted by css-extract-rspack-plugin
export default {"bold":"_ef7b0ce","fiatPrice":"_9d6c3bdc"};